<template>
    <v-container fill-height fluid>
        <v-row>
            <v-col class="d-flex justify-center">
                <v-sheet color="background">
                    <header>
                        <span class="text-h3 text-uppercase d-flex text-center" style="color: #ffc107">
                            SUSCRIPCIONES Y PAGOS
                        </span>
                        <!-- <article class="d-flex justify-center mt-2">
                            <p class="text-center">
                                These are about as basic as you get
                            </p>
                        </article> -->
                    </header>
                </v-sheet>
            </v-col>
        </v-row>
        <v-row wrap>
            <v-col md6>
                <materialfy-header-card cardTitle='BOTS' text="Here is a subtitle for this table" cardMinWidth="250"
                    :cardShowInnerList="false" :cardShowDivider="false">
                    <template v-slot:crdInner>
                        <v-data-table :headers="headersCart" :items="itemsCart" :items-per-page="5"
                            class="elevation-1 primary" :mobile-breakpoint="0">
                            <template v-slot:[`item.actions`]="{ item }">
                                <div v-if="!item.bot">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon small class="mr-2" dark v-on="on"
                                                @click="handleClick(item, 'addBot')">mdi-robot</v-icon>
                                        </template>
                                        <span>Agregar Bot</span>
                                    </v-tooltip>
                                </div>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon small class="mr-2" dark v-on="on"
                                            @click="handleClick(item, 'pay')">mdi-wallet</v-icon>
                                    </template>
                                    <span>Pagar</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon small class="mr-2" dark v-on="on"
                                            @click="handleClick(item, 'cancel')">mdi-delete</v-icon>
                                    </template>
                                    <span>Cancelar</span>
                                </v-tooltip>
                            </template>
                            <!-- <template slot="headerCell" slot-scope="{ header }">
								<span class="
										text-subtitle-1
										font-weight-light
										text-general text--darken-3
									" v-text="header.text" />
							</template>
							<template slot="items" slot-scope="{ item }">
								<td>{{ item.name }}</td>
								<td>{{ item.country }}</td>
								<td>{{ item.city }}</td>
								<td class="text-right">
									{{ item.salary }}
								</td>
							</template> -->
                        </v-data-table>
                    </template>
                    <template #crdActions>
                        <v-btn color="tertiary" @click="comprarBot" class="mb-2" :disabled="noMasBots"> COMPRAR BOT </v-btn>
                    </template>
                </materialfy-header-card>
            </v-col>

            <v-col md6>
                <materialfy-header-card color="general" flat full-width :cardShowInnerList="false"
                    :cardShowActions="false" :cardShowDivider="false" cardTitle="PAGOS"
                    text="Here is a subtitle for this table">
                    <template v-slot:crdInner>
                        <v-data-table :headers="headersPays" :items="itemsPays" class="elevation-1 primary">
                            <!-- <template slot="headerCell" slot-scope="{ header }">
								<span class="
										text-subtitle-1
										font-weight-light
										text-general text--darken-3
									" v-text="header.text" />
							</template>
        <template slot="items" slot-scope="{ item }">
								<td>{{ item.name }}</td>
								<td>{{ item.country }}</td>
								<td>{{ item.city }}</td>
								<td class="text-right">
									{{ item.salary }}
								</td>
							</template> -->
                        </v-data-table>
                    </template>
                </materialfy-header-card>
            </v-col>
        </v-row>
        <v-dialog v-model="dialogElegirBot" transition="dialog-top-transition" max-width="420">
            <template>
                <v-card>
                    <v-toolbar color="primary" dark>{{ msg_title }}</v-toolbar>
                    <v-card-text>
                        <div class="text-h6 pa-6">{{ msg_toast }}</div>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" text @click="eleccionTipoBot('estandard')">
                            ESTANDARD
                        </v-btn>
                        <v-btn color="error" text @click="eleccionTipoBot('auto')">
                            AUTOMATICO
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>
        <v-snackbar v-model="snackbarCheckPeriod" :color="color" :bottom="bottom" :top="top" :float-left="left"
            :float-right="right">
            <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
            <div>
                {{ msg_toast }}
            </div>
            <v-icon size="16" @click="snackbarCheckPeriod = false">
                mdi-close-circle
            </v-icon>
        </v-snackbar>
    </v-container>
</template>

<script>
import UserService from '../../services/user.service'

export default {
    components: {
    },
    data: () => ({
        // Variables
        idSuscripcion: '',
        // Table Cart
        headersCart: [
            { text: "Nombre", value: "tipoSuscripcion.nombre", align: "center" },
            { text: "Descripcion", value: "tipoSuscripcion.descripcion", align: "center" },
            { text: "Limite Bot", value: "tipoSuscripcion.limiteInversionPorBot", align: "center" },
            { text: "Par", value: "bot.pair", align: "center" },
            { text: "Iniciado", value: "bot.started", align: "center" },
            { text: "Fecha Fin", value: "fechaFin", align: "center" },
            { text: 'Acciones', value: 'actions', sortable: false, align: "center" }
        ],
        itemsCart: [],
        // Table bots
        headersBots: [
            { text: "Par", value: "pair", align: "center" },
            { text: "Cantidad por Trade", value: "quantity", align: "center" },
            { text: "Cantidad Bot", value: "amount", align: "center" },
            { text: "En marcha", value: "started", align: "center" },
            { text: "Porcentaje", value: "percent", align: "center" },
            { text: 'Acciones', value: 'actions', sortable: false, align: "center" }
        ],
        itemsBots: [],
        // Table Pays
        headersPays: [
            { text: "Fecha Pago", value: "fechaPago", align: "center" },
            { text: "Metodo Pago", value: "metodoPago", align: "center" },
            { text: "Precio", value: "monto", align: "center" },
            { text: "Estado Pago", value: "estadoPago", align: "center" },
        ],
        itemsPays: [],
        isOpenDialog: false,
        // SanckBar
        color: null,
        colors: ["purple", "info", "success", "warning", "error"],
        top: true,
        bottom: false,
        left: false,
        right: false,
        dialogElegirBot: false,
        snackbarCheckPeriod: false,
        msg_title: '',
        msg_toast: '',



        dialogTitle: '',
        dialog: false,
        checkboxAdmin: true,
        checkboxActive: false,
        editedIndex: -1,
        //this is the new item created by copying the userList item. its used in editing menu and methods
        editedItem: {
            first_name: "",
            last_name: "",
            email: "",
            isAdmin: true,
            isActive: false,
            lastSeen: '',
        },
        defaultItem: {
            first_name: "",
            last_name: "",
            email: "",
            isAdmin: true,
            isActive: false,
            lastSeen: `${new Date().toLocaleString()}`,
        },
    }),
    computed: {},
    mounted() {
        UserService.getCart().then(
            response => {
                this.diasRestantes = response.data.diasRestantes
                if (response.data.estado !== 'false') {
                    this.estado = 'ACTIVADA'
                } else {
                    this.estado = 'FINALIZADA'
                }
                if (response.data.botsDisponibles) {
                    this.invalid = false
                } else {
                    this.invalid = true
                }
                if (response.data.listSuscripcion.length > 1 && this.diasRestantes < 15) {
                    this.masSuscripcion = true
                }
                if (response.data.listSuscripcion.length === 5) {
                    this.noMasBots = true
                }
                this.itemsCart = response.data.listSuscripcion
                this.itemsPays = response.data.listPago

            },
            error => {
                this.content =
                    (error.response && error.response.data && error.response.data.message) ||
                    error.message ||
                    error.toString();
                if (error.response && error.response.status === 403 || error.response.status === 401) {
                    this.$store
                        .dispatch('logout', this.user) //calls the login action and passes login info
                        .then(() => this.$router.push('/')) //redirect to dash after login
                        .catch((err) => {
                            console.log(err)
                            this.snackbar = true //shows error on wrong pass
                        })
                }
            }
        );
    },
    methods: {
        menuActionClick(action) {
            if (action === "renovarTodo") {
                this.$router.push("/menu_suscripcion/?accion=update&idSuscripcion=all");
            }
        },
        handleClick(value, action) {
            switch (action) {
                case 'addBot':
                    this.openDialogTipoBot(value.id, 'Elige el tipo de bot', '¿ Que tipo de bot quieres añadir ?')
                    // if (value.bot === null) {
                    //     this.$router.push('/bot_save/?idSuscripcion=' + value.id)
                    // }
                    break;
                case 'pay':
                    this.checkPeriodBot(value)
                    break;
                case 'cancel':
                    this.idSuscripcion = value.id
                    this.openDialogQuestion()
                    break;
            }
        },
        checkPeriodBot(value) {
            UserService.chekPeriodBot(value.id).then(
                response => {
                    if (response) {
                        if (response.data > 15) {
                            this.msgError = 'Todavia le faltan ' + response.data + ' días para que finalice la suscripcón. '
                            this.types = 'success'
                            this.snackPeriod('ACTUALIZACIÓN DE SUSCRIPCIÓN', this.msgError)
                        } else {
                            this.$router.push("/menu_suscripcion/?accion=update&idSuscripcion=" + value.id)
                            // ?suscripcion=" + this.idSuscripcion + '&tipo=' + this.selected.id
                        }
                    }
                },
                error => {
                    this.content =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                    if (error.response && error.response.status === 403 || error.response.status === 401) {
                        this.$store
                            .dispatch('logout', this.user) //calls the login action and passes login info
                            .then(() => this.$router.push('/')) //redirect to dash after login
                            .catch((err) => {
                                console.log(err)
                                this.snackbar = true //shows error on wrong pass
                            })
                    }
                }
            );
        },
        snackPeriod( title, message) {
            // this.top = false;
            this.bottom = false;
            this.left = false;
            this.right = false;
            this.color = "secondary"
            this.msg_title = title
            this.msg_toast = message
            this.snackbarCheckPeriod = true;
        },
        // snackElegirBot(color, title, message) {
        //     this.top = false;
        //     this.bottom = false;
        //     this.left = false;
        //     this.right = false;
        //     this.color = "primary"
        //     this.msg_title = title
        //     this.msg_toast = message
        //     this.snackbarElegirBot = true;
        // },
        openDialogQuestion() {
            this.$refs.dialogQuestions.openModal()
            this.$refs.dialogQuestions.component = 'DELETE_SUSCRIPCION'
            this.$refs.dialogQuestions.tituloDialog = 'Cancelar Suscripcion'
            this.$refs.dialogQuestions.question = '¿ Desea realmente cancelar la suscripción ?'
        },
        openDialogTipoBot(idSuscripcion, title, message) {
            this.idSuscripcion = idSuscripcion
            this.msg_title = title
            this.msg_toast = message
            this.dialogElegirBot = true
        },
        cancelSuscripcion() {
            UserService.cancelarSuscripcion(this.idSuscripcion).then(
                response => {
                    setTimeout(() => (this.responseCancel('success', response.data)), 2000)
                },
                error => {
                    this.content =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                    setTimeout(() => (this.responseCancel('error', error.response.data)), 2000)
                }
            );
        },
        eleccionTipoBot(value) {
            // console.log(value)
            if (value === 'estandard') {
                this.$router.push('/bot-save/?idSuscripcion=' + this.idSuscripcion + '&tipo=estandard')
            } else if (value === 'auto') {
                this.$router.push('/bot-save/?idSuscripcion=' + this.idSuscripcion + '&tipo=auto')
            }
        },
        responseCancel(response, msg) {
            this.$refs.dialogMessages.openModal()
            this.$refs.dialogMessages.component = 'CANCELAR SUSCRIPCION'
            this.$refs.dialogMessages.tituloDialog = 'CANCELAR SUSCRIPCION'
            this.$refs.dialogMessages.msgError = msg
            this.$refs.dialogMessages.isShow = true
            if (response === 'success') {
                this.$refs.dialogMessages.types = 'success'
                this.successful = true
            } else {
                this.$refs.dialogMessages.types = 'error'
                this.successful = false
            }
        },
        comprarBot() {
            this.$router.push("/menu-suscripciones/?accion=new")
        },
        closeAlert() {
            if (this.successful) {
                this.$router.go()
            }
        }
    }
}
</script>
<style>
/* tbody tr:nth-of-type(even) {
    background-color: rgba(236, 237, 237);
  }

  tbody tr:nth-of-type(odd) {
    background-color: rgb(250 ,250, 250);
  }

  .v-data-table-header {
    background-color: rgba(182, 183, 187);
    color: white;
  }

  .v-data-footer {
    background-color: rgb(250 ,250, 250);
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  } */
</style>
